function addFormScrollBehaviour() {
  const form = document.querySelector('.minimal-landing-page__form-container');
  const footer = document.querySelector('.course-footer__container');
  const scrollable = document.querySelector('body');

  if (!form || !footer || !scrollable) {
    return;
  }

  scrollable.addEventListener('scroll', () => {
    const footerTop = footer.getBoundingClientRect().top + scrollable.scrollTop;
    const formHeight = form.offsetHeight;
    const { scrollTop } = scrollable;


    const triggerPoint = footerTop - formHeight;

    if (scrollTop >= triggerPoint) {
      form.classList.add('hide');
    } else {
      form.classList.remove('hide');
    }
  });
}


export default {
  initialize: addFormScrollBehaviour,
};
